.ErrorStatus {
  align-self: center;
  justify-self: center;
  grid-column: 1 / -1;
  max-width: 800px;
  display: grid;
  grid: auto / auto;
  border-radius: var(--radius-lg);
  height: fit-content;
  align-items: center;
  justify-items: center;
  background-color: var(--bg);
  padding: var(--space-xl);
  gap: var(--space);
  text-align: center;

  pre {
    text-align: left;
    white-space: pre-wrap;
    word-break: break-all;
    font-size: 1rem;
    margin: var(--space-lg) 0;
  }
}

.ErrorStatusContent {
  display: grid;
  grid: auto / auto;
  align-items: center;
  gap: var(--space-sm);

  h1 {
    font-size: 2.5rem;
    font-weight: 600;
    color: var(--black);
  }

  span {
    font-size: 1rem;
    color: var(--black);
  }
}
